import React from "react"
import clsx from "clsx"
import { isMobileOnly } from "react-device-detect"
import { useTranslation } from "react-i18next"
import { NavLink, useNavigate, useParams } from "react-router-dom"

import ProtectedLayout from "layouts/Protected"
import { useBikeStoreProcess } from "hooks"
import Logo from "components/Elements/logos/Logo"
import { CaretIcon } from "components/Elements/Icons"
import { InsuranceForm } from "./Partials/Bicytrust"
import { privateRoutes } from "router/routes"
import { isNotEmpty } from "utils"

export const BikeInsurancePage: React.FC = () => {
	const { setShowOwner, bikeProcessState, fetchBike } = useBikeStoreProcess()

	const { currentBike: bike, showOwner } = bikeProcessState

	const { slug } = useParams()
	const { t } = useTranslation()
	const navigate = useNavigate()

	const goBack = () => (showOwner ? setShowOwner(false) : navigate(-1))

	React.useEffect(() => {
		if (slug !== bike?.code) fetchBike(slug)
	}, []) // eslint-disable-line

	return (
		<ProtectedLayout className="py-5">
			<div className="l-container">
				<div
					className={clsx("c-section-title mb-7", {
						"px-8": !isMobileOnly,
						"px-6": isMobileOnly,
					})}
				>
					<div className="c-section-title__content justify-between">
						<div className="flex items-center justify-start w-full">
							<button
								data-cy="button-back-to-search"
								onClick={goBack}
								className="flex"
								aria-label={t("back_to_search", { ns: "bike" })}
							>
								<span className="flex py-2">
									<CaretIcon size={26} />
								</span>
							</button>
							<h1 className="c-section-title__title c-h2 text-primary ml-4">
								{slug ? slug : ""}
							</h1>
						</div>
						<div className="flex items-center justify-end w-full">
							<span className="uppercase">{t("identify_by", { ns: "bike" })}</span>
							<Logo
								name={bike?.identifier}
								className="py-2 u-inline-flex"
								defaultColor={true}
							/>
						</div>
					</div>
				</div>

				<div className="c-submenu px-7 pb-7">
					<div className="flex items-center justify-start w-full">
						<div className={"c-submenu__item px-5 "}>
							<NavLink
								to={`${privateRoutes.bike.basePath}/${bike?.code}`}
								className="flex"
							>
								{t("bikeInfo", { ns: "bike" })}
							</NavLink>
						</div>
						<div className={"c-submenu__item px-5 "}>
							<NavLink
								to={`${privateRoutes.bikeInsurance.basePath}/${bike?.code}`}
								className="flex"
							>
								{t("bicytrustInsurance", { ns: "bike" })}
							</NavLink>
						</div>
					</div>
				</div>

				<div
					className={clsx({
						"px-8": !isMobileOnly,
						"px-6": isMobileOnly,
					})}
				>
					{isNotEmpty(bike) && <InsuranceForm />}
				</div>
			</div>
		</ProtectedLayout>
	)
}
